import React from 'react';

const GradientOverlay = ({ variant = 'teal', opacity = 0.15 }) => {
  const gradients = {
    teal: `linear-gradient(135deg, rgba(13, 115, 119, ${opacity}) 0%, rgba(10, 68, 71, ${opacity * 0.5}) 50%, rgba(201, 162, 39, ${opacity * 0.3}) 100%)`,
    gold: `linear-gradient(135deg, rgba(201, 162, 39, ${opacity * 0.4}) 0%, rgba(13, 115, 119, ${opacity * 0.5}) 50%, rgba(10, 68, 71, ${opacity * 0.3}) 100%)`,
    subtle: `linear-gradient(180deg, rgba(13, 115, 119, ${opacity * 0.3}) 0%, transparent 50%, rgba(201, 162, 39, ${opacity * 0.2}) 100%)`,
    diagonal: `linear-gradient(45deg, rgba(232, 244, 245, 0.8) 0%, rgba(255, 255, 255, 0.9) 25%, rgba(232, 244, 245, 0.7) 50%, rgba(255, 255, 255, 0.95) 75%, rgba(232, 244, 245, 0.6) 100%)`
  };

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: gradients[variant] || gradients.teal,
      pointerEvents: 'none',
      zIndex: 0
    }} />
  );
};

export default GradientOverlay;
